import { Component, ViewChild } from '@angular/core';
import { ButtonComponent } from '@improver/components/buttons';
import { ContextMenuDirective, ContextMenuItemComponent } from '@improver/components/context-menu';
import { BaseNavigationService } from '@improver/infrastructure/navigation-data-layer';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-help-center-dropdown',
  templateUrl: 'help-center-dropdown.component.html',
  styleUrls: ['help-center-dropdown.component.scss'],
  imports: [ButtonComponent, ContextMenuDirective, TranslateModule, ContextMenuItemComponent],
})
export class HelpCenterDropdownComponent {
  @ViewChild(ContextMenuDirective) contextMenuDirective: ContextMenuDirective;

  constructor(private baseNavigationService: BaseNavigationService) {}

  openDropdown() {
    this.contextMenuDirective.open(new Event('click'));
  }

  goToHelpCenter() {
    this.baseNavigationService.goToHelpCenter();
  }
}
